var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNzd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.2673C24 18.8947 18.6274 24.2673 12 24.2673C5.37262 24.2673 0 18.8947 0 12.2673C0 12.2702 12 0.268646 12 0.267334C18.6274 0.267334 24 5.63996 24 12.2673Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9688 12.2683H12.0009C12.0009 12.2575 12.0009 12.2469 12.0009 12.2361C11.9902 12.2468 11.9795 12.2575 11.9688 12.2683Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.52819C12 4.41671 12 3.03319 12 0.267334H11.998C5.3715 0.268459 0 5.64057 0 12.2673H6.26086V8.74182L9.78642 12.2673H11.9679C11.9786 12.2566 11.9894 12.246 12 12.2352C12 11.4268 12 10.7054 12 10.0538L8.47443 6.52819H12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07027 1.83374C4.19344 2.90244 2.63316 4.46272 1.56445 6.33955V12.2685H4.69491V4.96429V4.96419H11.9993C11.9993 3.97687 11.9993 3.03627 11.9993 1.83374H6.07027Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 10.7925L7.73739 6.52905C7.73739 6.52905 6.26172 6.52915 6.26172 6.52905V6.52915L12.0008 12.2681H12.0008C12.0008 12.2681 12.0008 11.2506 12.0008 10.7925Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7808 9.17358L21.0398 9.97074H21.878L21.1999 10.4634L21.4589 11.2605L20.7808 10.7679L20.1027 11.2605L20.3617 10.4634L19.6836 9.97074H20.5218L20.7808 9.17358Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7845 14.9119L18.173 16.1076H19.4302L18.413 16.8466L18.8016 18.0423L17.7845 17.3033L16.7673 18.0423L17.1559 16.8466L16.1387 16.1076H17.3959L17.7845 14.9119Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8968 5.52124L18.2206 6.51775H19.2683L18.4206 7.13346L18.7445 8.12992L17.8968 7.51403L17.0492 8.12992L17.373 7.13346L16.5254 6.51775H17.573L17.8968 5.52124Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.013 9.13843L15.4015 10.3342H16.6587L15.6416 11.0731L16.0302 12.2689L15.013 11.5299L13.9958 12.2689L14.3844 11.0731L13.3672 10.3342H14.6244L15.013 9.13843Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNzd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NZD.570e80d4a0dc77d05334d63760178043.svg";